import { apiUrl } from 'src/utils/resource.js'

/**
 * A common class used by various components that work with files.
 * Can be formed from a locally selected file, or from a media object from the server.
 */
export class AppFile {

    constructor(data = {}) {
        this.id = data.id
        this.filename = data.file_name || data.name
        this.size = data.size || 0
        this.mime = data.mime_type || data.type
        this.collection = data.collection_name
        this.customProperties = data.custom_properties
        this.createdAt = dayjs(data.created_at)
        this.updatedAt = dayjs(data.updated_at)

        // Locally selected file (if any) to be uploaded
        this.file = data instanceof File ? data : undefined // setting to null means delete the file
    }

    getDownloadUrl() {
        let timestamp = this.updatedAt.unix()
        return apiUrl(`media/${this.id}/download?t=${timestamp}`)
    }

    /**
     * Get a suitable fontawesome icon from the file
     */
    getIcon() {
        switch (this.mime) {
            case 'application/vnd.ms-excel':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                return 'fa-file-excel'
            case 'application/msword':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                return 'fa-file-word'
            case 'application/vnd.ms-powerpoint':
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                return 'fa-file-powerpoint'
            case 'application/pdf':
                return 'fa-file-pdf'
            default:
                return 'fa-file'
        }
    }
}
